/**
 * Design tokens for the revised Edit Template screen.
 * Values mirror the Figma / revision-history-mockup.html light palette so the
 * new screen can be reviewed against the design before it is wired to data.
 */
export const tokens = {
  accent: "#8B2FA6",
  accentHover: "#7A2790",
  accentSoft: "#F8ECFA",
  accentSoftBorder: "#ECD3F0",

  bg: "#FAFAFB",
  surface: "#FFFFFF",
  border: "#E6E6EA",
  borderStrong: "#D4D4DC",

  text: "#1A1A1F",
  textMuted: "#666672",
  textFaint: "#9797A3",

  success: "#1B8A5A",
  successSoft: "#E7F5EE",
  info: "#2563EB",
  infoSoft: "#EAF0FE",
  danger: "#C23B31",
  dangerSoft: "#FCEBEA",
  dangerBorder: "#F3C4BF",

  codeBg: "#F6F6F8",

  radius: "6px",
  cardRadius: "10px",
  shadowSm: "0 1px 2px rgba(20, 18, 26, 0.06)",

  monoFont:
    'ui-monospace, SFMono-Regular, "Roboto Mono", Menlo, Consolas, monospace',
} as const;

/** Stable per-editor avatar colours, picked by hashing the e-mail. */
const AVATAR_COLORS = ["#8B2FA6", "#0E7C86", "#B7791F", "#2563EB", "#C23B31"];

export const getAvatarColor = (email: string): string => {
  if (!email) return tokens.textFaint;
  let hash = 0;
  for (let i = 0; i < email.length; i += 1) {
    hash = (hash + email.charCodeAt(i)) % AVATAR_COLORS.length;
  }
  return AVATAR_COLORS[hash];
};

export const getInitial = (email: string): string =>
  email ? email.charAt(0).toUpperCase() : "?";

/** Shared card surface used by every section of the screen. */
export const cardSx = {
  backgroundColor: tokens.surface,
  border: `1px solid ${tokens.border}`,
  borderRadius: tokens.cardRadius,
  boxShadow: tokens.shadowSm,
};
